import {

  login,
  signup,

  getMe,

  logout,
  logoutAll,

  sendOtp,
  verifyOtp,

  sendEmailVerification,
  verifyEmail,

  forgotPassword,
  resetPassword,

  refreshSession

} from "../../../api/authApiAdmin/authApi";

import {

  authStart,
  authSuccess,
  authFailure,

  logoutSuccess,

  setOtpState,
  clearOtpState

} from "../../reducers/slices/authSlice";

import {

  saveAuth,
  clearAuth

} from "../../../utils/authStorage";


export const loginAction =
  payload =>
  async dispatch => {

    try {

      dispatch(
        authStart()
      );

      const data =
        await login(
          payload
        );
  
      dispatch(
        authSuccess(
          data
        )
      );

      saveAuth(data);

      return data;

    } catch (error) {

      dispatch(
        authFailure(
          error.response?.data
            ?.message ||
          error.message
        )
      );

      throw error;
    }
  };


  export const signupAction =
  payload =>
  async dispatch => {

    try {

      dispatch(
        authStart()
      );

      const data =
        await signup(
          payload
        );

      dispatch(
        authSuccess(
          data
        )
      );

      saveAuth(data);

      return data;

    } catch (error) {

      dispatch(
        authFailure(
          error.response?.data
            ?.message ||
          error.message
        )
      );

      throw error;
    }
  };


  export const getMeAction =
  () =>
  async dispatch => {

    try {

      const data =
        await getMe();

      return data;

    } catch (error) {

      throw error;
    }
  };

  export const sendOtpAction =
  payload =>
  async dispatch => {

    try {

      const data =
        await sendOtp(
          payload
        );

      dispatch(
        setOtpState({

          verificationId:
            data.verificationId,

          purpose:
            payload.purpose
        })
      );

      return data;

    } catch (error) {

      throw error;
    }
  };


  export const verifyOtpAction =
  payload =>
  async dispatch => {

    try {

      const data =
        await verifyOtp(
          payload
        );

      return data;

    } catch (error) {

      throw error;
    }
  };

  export const forgotPasswordAction =
  email =>
  async dispatch => {

    try {

      const data =
        await forgotPassword(
          email
        );

      dispatch(
        setOtpState({

          verificationId:
            data.verificationId,

          purpose:
            "forgot_password"
        })
      );

      return data;

    } catch (error) {

      throw error;
    }
  };

  export const resetPasswordAction =
  payload =>
  async dispatch => {

    try {

      const data =
        await resetPassword(
          payload
        );

      dispatch(
        clearOtpState()
      );

      return data;

    } catch (error) {

      throw error;
    }
  };

  export const sendEmailVerificationAction =
  () =>
  async dispatch => {

    try {

      const data =
        await sendEmailVerification();

      dispatch(
        setOtpState({

          verificationId:
            data.verificationId,

          purpose:
            "email_verification"
        })
      );

      return data;

    } catch (error) {

      throw error;
    }
  };

  export const verifyEmailAction =
  verificationId =>
  async dispatch => {

    try {

      const data =
        await verifyEmail(
          verificationId
        );

      return data;

    } catch (error) {

      throw error;
    }
  };

  export const logoutAction =
  () =>
  async dispatch => {

    try {

      await logout();

    } catch (error) {

      console.log(error);
    }

    clearAuth();

    dispatch(
      logoutSuccess()
    );
  };

  export const logoutAllAction =
  () =>
  async dispatch => {

    try {

      await logoutAll();

    } catch (error) {

      console.log(error);
    }

    clearAuth();

    dispatch(
      logoutSuccess()
    );
  };